<template>

    <FloatingPanel>

        <div class="common-canvas-blocks-common-leftTextImageRight-BlockPanel">

            <CommonInputs
                :options="options"/>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/AbstractPanel";
import FloatingPanel from "@galaxy/js/common/canvas/editor/canvas/document/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/components/common/canvas/editors/CommonInputs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
    },

}

</script>

<style lang="scss" scoped>

.common-canvas-blocks-common-leftTextImageRight-BlockPanel {

}

</style>
